<template>
  <a-modal
    title="线边倒冲"
    :visible="visible"
    :confirm-loading="loading"
    :ok-button-props="{ props: { disabled: !warehouse || loading } }"
    :cancel-button-props="{ props: { disabled: loading } }"
    :mask-closable="false"
    :closable="!loading"
    :keyboard="!loading"
    ok-text="确认"
    cancel-text="取消"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="back-flush-modal__warehouse">
      <span class="back-flush-modal__label">倒冲仓库：</span>
      <a-select
        v-model="warehouse"
        placeholder="请选择倒冲仓库"
        :disabled="loading"
        class="back-flush-modal__select"
      >
        <a-select-option
          v-for="item in warehouseOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>
  </a-modal>
</template>

<script>
import { apiXbcBackFlushMaterialIssuance } from '@/api/mes/workOrderManage/workOrderDesk'

const WAREHOUSE_OPTIONS = [
  {
    value: 'SIE_WM_WMWHSE1',
    label: 'VMI仓(五金)'
  },
  {
    value: 'SIE_WM_WMWHSE2',
    label: '产业园仓(裁床)'
  }
]

export default {
  name: 'BackFlushModal',
  data () {
    return {
      visible: false,
      loading: false,
      warehouse: undefined,
      warehouseOptions: WAREHOUSE_OPTIONS
    }
  },
  methods: {
    show () {
      this.reset()
      this.visible = true
    },
    reset () {
      this.warehouse = undefined
    },
    handleCancel () {
      if (this.loading) return
      this.visible = false
      this.reset()
    },
    handleConfirm () {
      const route = this.warehouseOptions.find(item => item.value === this.warehouse)
      if (!route) {
        this.$message.warning('请选择倒冲仓库')
        return
      }

      this.loading = true
      apiXbcBackFlushMaterialIssuance({
        datasource: route.value
      }).then(res => {
        if (res?.code === 200) {
          this.$message.success(res?.data || '操作成功')
          this.visible = false
          this.reset()
          this.$emit('success')
        } else {
          this.$message.error(res?.msg || '操作失败')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.back-flush-modal__warehouse {
  display: flex;
  align-items: center;
}

.back-flush-modal__label {
  width: 90px;
}

.back-flush-modal__select {
  width: 260px;
}
</style>
